<template>
  <div>
    <v-app-bar color="primary" dark>

      <span style="">
      <v-img src="@/assets/logo_200_light.png" alt="logo" ></v-img>
			</span>
      
      <v-spacer></v-spacer>
      
      <Language />
      
    </v-app-bar>
    
    <slot/>

    <v-footer dark color="primary" app>
      <v-spacer />
      <span >Termo Profil &copy;{{ new Date().getFullYear() }}</span>
      <v-spacer />
    </v-footer>
  </div>
</template>

<script>

import Language from '@/components/Language.vue'

export default {
    components: {
            Language
    }
}


</script>